import {ActivityLog} from "../types.ts";
import {v4 as uuid4} from "uuid";

function pickRandom<T>(list: T[]): T {
    return list[Math.floor(Math.random() * list.length)];
}

// FNP-36: the generator must populate every field the edit form considers
// required so a generated record round-trips cleanly through the edit form.
// The form's "Record Type" label is the usageType field; backend additionally
// declares recordType: String! on ActivityLog, so we set it too even though
// the form does not render it (so the underlying backend record is consistent).
const generateRandomActivityLog = (): ActivityLog => {

    const action = pickRandom(['added', 'removed']);
    const recordId = uuid4();
    const usageType = pickRandom(['ACCOUNT', 'ORGANIZATION', 'REGISTRAR', 'DOMAIN_NAME', 'ALIAS', 'MESSAGE']);
    const recordType = usageType;
    const username = pickRandom([
        'openidconnectprovider_9861a3e0-90d1-70f4-5dd9-1fedc8aabe7b',
        'google_101785956163867340574',
        '895a6ac3-4402-4151-a035-6b15e8eb3eca',
    ]);

    return {
        id: uuid4(),
        action,
        created: new Date().toISOString(),
        recordId,
        recordType,
        usageType,
        username,
        value: Math.floor(Math.random() * 100) + 1,
    } as ActivityLog;
};

export const useRandomActivityLogGenerator = () => {
    return {
        generateRandomActivityLog,
    };
};

